import { auth, db } from "../firebase-config";
import { useState, useEffect } from 'react';
import RateMyClassLogo from '../assets/RateMyClassLogo.png';
import {SearchIcon} from '@chakra-ui/icons';
import { collection, query, where, getDocs, limit } from "firebase/firestore";
import {
  IconButton,
  ChakraProvider,
  FormControl,
  Card,
  Text,
  List,
  ListItem,
  FormLabel,
  Button,
  Input,
  Box,
  Select,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderMark,
  Textarea,
  Tooltip,
  Center,
  Radio,
  RadioGroup,
  Stack,
  Link,
  VStack,
  Code,
  Grid,
  theme,
  useToast,
  InputGroup,
  chakra,
} from '@chakra-ui/react';
import { ColorModeSwitcher } from '../utils/ColorModeSwitcher';
import { Logo } from '../assets/logo.svg';
import { useNavigate } from "react-router-dom";
import Kirkland from '../assets/Kirkland_Image.png';


export default function Page() {
  const [deptCodes, setDeptCodes] = useState([]);
  const [departmentDocID, setDepartmentDocID] = useState("");
  const [coursesArray, setCoursesArray] = useState([]);
  // changing the query in line 46 eventually
  const searchNameQuery = async (queryTerm) => {
    const q = query(collection(db, "departments"), where("deptName", ">=", queryTerm), limit(5));
    const querySnapshot = await getDocs(q);
    var docArr = [];
    var codeArr = [];
    var coursesArr = [];
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      docArr.push(doc.data()["deptName"]);
      codeArr.push(doc.data()["deptCode"]);
      coursesArr.push("");
    });
    setCoursesArray(coursesArr);
    setDeptCodes(codeArr);
    return docArr;
  }
  /*
  const searchCodeQuery = async (queryTerm) => {
    const q = query(collection(db, "departments"), where("deptCode", "==", queryTerm.replace(/\d+/g, '')), limit(5));
    const querySnapshot = await getDocs(q);
    const docArr = [];
    let classArr = [];
    let codeArr = [];
  
    for (const doc of querySnapshot.docs) {
      const departmentDocID = doc.id;
      const info = query(collection(db, `departments/${departmentDocID}/courses`), where("courseNum", "==", queryTerm.replace(/\D/g, '')));
      const querySnapshot3 = await getDocs(info);
  
      if (!querySnapshot3.empty) {
        const courseDoc = querySnapshot3.docs[0];
        classArr.push(courseDoc.data().courseNum);
        codeArr.push(doc.data().deptCode);
        docArr.push(doc.data().deptName);
      } else {
        classArr.push("");
        codeArr.push("");
        docArr.push("No course found...");
      }
    }
  
    setDeptCodes(codeArr);
    setCoursesArray(classArr);
    return docArr;
  };
  
*/
 const invalidToast = useToast();
 document.body.style.background = 'lightyellow';
 const [className, setClass] = useState("");
 const [queryRes, setQueryRes] = useState([]);
 const [departmentName, setDepartment] = useState("");

 const labelStyles = {
    mt: '2',
    ml: '-2.5',
    fontSize: 'sm',
  }

  const departmentOrCourse = (courseNumString, deptName, deptCode) => {
    if (courseNumString === "") {
      return deptName;
    } else {
      return deptCode+courseNumString;
    }
  }

  return (
    <ChakraProvider theme={theme}>
      <Center>
      <Box style = {{position: 'table', width: '100%', backgroundImage: `url(${Kirkland})`, backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: '100vh'}}>
      
      <Box style = {{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}>
      <VStack spacing="1px">
        <div class="center-image">
          <img src={RateMyClassLogo} alt = "Rectangular logo" />
        </div>

     <VStack spacing="30px">

      <Card width='600px'  style={{backgroundColor: 'lightyellow'}} variant={'filled'}>
        <FormControl>
            <Input value={departmentName} placeholder = "Enter department name (ex. 'Computer Science' NOT 'computer science')"  _placeholder={{ opacity: 0.75, color: 'grey.400' }} onChange={(e) => setDepartment(e.target.value) } />
        </FormControl>
        
      </Card>
         <Button colorScheme="yellow" onClick={async () => {
          if (departmentName === "") {
            invalidToast({
              position: "bottom-right",
              title: 'Submission failed.',
              status: 'error',
              description: "Fill in one field before searching!",
              duration: 9000,
              isClosable: true,
            })
          } else {
            var temp = await searchNameQuery(departmentName);
            if (temp.length === 0) {
              invalidToast({
                position: "bottom-right",
                title: 'Please Enter Department Case Sensitive',
                status: 'warning',
                description: "No results found!",
                duration: 9000,
                isClosable: true,
              })
              setQueryRes([]);
            } else {
              setQueryRes(temp);
            }
          }  
        }

        }>Search</Button>
        <Card variant={'filled'} width='600px' style={{backgroundColor: 'lightyellow'}}>
        <List>
          {queryRes.map((item, index) => (
            <ListItem key={index}>
              <Link href={`/departments/${deptCodes[index]}/${coursesArray[index]}`}>{departmentOrCourse(coursesArray[index],item,deptCodes[index])}</Link>
            </ListItem>
          ))}
        </List>
        </Card>
        </VStack>
        </VStack>
        </Box>
        </Box>
      </Center>
    </ChakraProvider>
  );
}


/*

      <Card variant={'filled'} width='600px' style={{backgroundColor: 'lightyellow'}} >
       <FormControl>
            <Input type = 'class' value={className} placeholder = "Enter class name (ex. CS1101)"  _placeholder={{ opacity: 0.75, color: 'grey.400' }} onChange={(e) => setClass(e.target.value) } />
        </FormControl>
      </Card>
      */